/**
 * Jobs Configuration
 *
 * This file allows you to configure additional jobs and their restrictions
 * without modifying component code.
 *
 * - additionalJobs: Jobs to show in the UI even if not returned by the backend API
 * - restrictedJobs: Jobs that cannot be run between 1:30 PM and 5:00 PM PST (market hours)
 */

export interface JobsConfig {
  /**
   * Additional job names to display in the Available Jobs list.
   * These will be merged with jobs returned from the backend API.
   * Useful for jobs that exist but aren't registered in the backend's job names list.
   */
  additionalJobs: string[];

  /**
   * Job names that have time-based execution restrictions.
   * These jobs cannot be run between 1:30 PM and 5:00 PM PST.
   */
  restrictedJobs: string[];
}

const jobsConfig: JobsConfig = {
  additionalJobs: [
    // Add job names here that you want to appear in the UI
    // Example: "my-custom-job"
    "contract-tradable-times-job",
  ],

  restrictedJobs: [
    // Jobs that cannot run during market hours (1:30 PM - 5:00 PM PST)
    "contract-historical-data-job",
    "forex-historical-data-job",
  ],
};

export default jobsConfig;


